
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M366 350H146c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15zM366 410H146c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15zM271 305c0 8.284 6.716 15 15 15h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15z"}}),_c('path',{attrs:{"d":"M426 0H142.15a14.996 14.996 0 00-10.606 4.394l-56.15 56.15A14.996 14.996 0 0071 71.15V497c0 8.284 6.716 15 15 15h340c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15zm-15 482H101V77.364L148.363 30H411v452z"}}),_c('path',{attrs:{"d":"M217.144 194.182c-8.272 0-14.804 10.885-14.804 18.287 0 13.933 21.334 27.43 47.458 28.301v5.442c0 3.048 3.483 5.878 8.272 5.878 4.137 0 8.272-2.83 8.272-5.878v-6.313c25.471-4.136 42.887-20.464 42.887-47.458 0-29.389-23.076-39.621-42.887-47.023v-31.784c14.15 1.088 18.287 8.055 25.471 8.055 9.579 0 13.497-11.973 13.497-17.851 0-15.021-25.471-18.504-38.968-18.939v-5.442c0-3.048-4.136-5.878-8.272-5.878-4.789 0-8.272 2.83-8.272 5.878v6.095c-23.076 3.266-43.539 16.545-43.539 44.193 0 27.865 23.511 37.226 43.539 44.846v35.267c-16.11-2.832-23.511-15.676-32.654-15.676zm47.022-13.715c7.837 3.701 13.279 8.272 13.279 15.457 0 7.837-5.878 11.974-13.279 13.715v-29.172zm-26.124-53.988c0-5.225 4.137-10.232 13.933-12.191v25.906c-8.273-3.484-13.933-7.402-13.933-13.715z"}})])
          )
        }
      }
    